<template>
  <div>
    <v-card outlined class="rounded-card">
      <v-subheader class="font-weight-bold text--primary">Produtos</v-subheader>
      <v-divider/>
      <v-list>
        <template v-for="(produto, index) in produtos">
          <v-list-item :key="produto.id">
            <v-list-item-content>
              <v-row dense>
                <v-col cols="12" class="body-1">
                  <px-span-tooltip v-if="checkCodigo(produto.produto)"
                                   top
                                   :text="labelCodigo(produto.produto)"
                                   tooltip="Código do item"/>
                  {{ produto.produto.descricao }}
                  <span>
                    ({{produto.quantidade
                      | number(getCurrencyFormat(produto.produto.casasDecimais))}}
                    {{produto.unidadeMedida.descricao}})
                  </span>
                  <px-situacao-cotacao-produto-fornecedor
                    v-if="!isItemValido(produto)"
                    :situacao="produto.situacao"/>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="4">
                  <span class="caption font-weight-bold">Código de referência do fornecedor</span>
                  <div>
                    {{ codigoReferencia(produto.produto) | naoInformado }}
                  </div>
                </v-col>
                <v-col cols="12" sm="4">
                  <span class="caption font-weight-bold">Especificação do produto</span>
                  <px-show-large-text :large-text="produto.especificacaoProduto"/>
                </v-col>
                <v-col cols="12" sm="4">
                  <span class="caption font-weight-bold">Observação externa do produto</span>
                  <px-show-large-text :large-text="observacaoExterna(produto)"/>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="4">
                  <span class="caption font-weight-bold">Finalidade da compra</span>
                  <div v-if="produto.finalidadeCompra">
                    <px-finalidade-compra-value :finalidade-compra="produto.finalidadeCompra"/>
                  </div>
                  <div v-else>
                    Não informado
                  </div>
                </v-col>
                <v-col cols="12" sm="4">
                  <span class="caption font-weight-bold">Prazo de entrega</span>
                  <div>
                    {{ produto.dataPrevisaoEntrega | date | naoInformado }}
                  </div>
                </v-col>
                <v-col cols="12" sm="4">
                  <span class="caption font-weight-bold">Anexos</span>
                  <div v-if="produto.arquivos.length">
                    <px-anexo-chip :files="produto.arquivos"
                                   :download-base-path="downloadBasePath"/>
                  </div>
                  <div v-else>
                    Nenhum anexo informado
                  </div>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
          <v-divider v-if="index !== (produtos.length - 1)"
                     :key="`v-div${produto.id}`"/>
        </template>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import { SituacoesCotacao } from 'px-business-components';
import { CasaDecimalUtils, FornecedorProdutoUtils } from 'px-components';

export default {
  props: {
    produtos: Array,
    idFornecedor: [String, Number],
    idSolicitacao: [String, Number],
  },
  computed: {
    isItemValido() {
      return (item) => SituacoesCotacao.ABERTAS.includes(item.situacao);
    },
    downloadBasePath() {
      return `/fornecedor/solicitacoes-respostas/${this.idSolicitacao}/file`;
    },
    getCurrencyFormat() {
      return (item) => CasaDecimalUtils.getCurrencyFormat(item);
    },
    labelCodigo() {
      return (item) => `${item.codigo} - `;
    },
    checkCodigo() {
      return (item) => item.codigo;
    },
    observacaoExterna() {
      return (produto) => produto.observacaoExterna ?? produto.produto.observacaoExterna;
    },
    codigoReferencia() {
      return (produto) => FornecedorProdutoUtils
        .getCodigoReferenciaFornecedor(produto.fornecedoresProduto, this.idFornecedor);
    },
  },
};
</script>
